function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isDirectory } from '@deephaven/file-explorer';
export class MockFileStorageTable {
  constructor(items) {
    _defineProperty(this, "items", void 0);
    _defineProperty(this, "onUpdateCallback", void 0);
    this.items = items;
  }

  /* eslint-disable class-methods-use-this */
  setSearch(search) {
    // no-op
  }
  setExpanded(path, expanded) {
    // only sets expansion for the FileExplorer in NewItemModal
    if (path.charAt(path.length - 1) === '/') {
      for (var i = 0; i < this.items.length; i += 1) {
        var item = this.items[i];
        if (isDirectory(item) && ("".concat(item.filename, "/") === path || item.filename === path)) {
          item.isExpanded = expanded;
        }
      }
    }
    return Promise.resolve();
  }
  collapseAll() {
    for (var i = 0; i < this.items.length; i += 1) {
      var item = this.items[i];
      if (isDirectory(item)) {
        item.isExpanded = false;
      }
    }
    return Promise.resolve();
  }
  getViewportData() {
    return Promise.resolve({
      items: this.items,
      // Fill in with mock items
      offset: 0
    });
  }
  getSnapshot(sortedRanges) {
    return _asyncToGenerator(function* () {
      throw new Error('Method not implemented.');
    })();
  }
  setViewport(viewport) {
    var _this = this;
    return _asyncToGenerator(function* () {
      var _this$onUpdateCallbac;
      var loadedViewportData = yield _this.getViewportData();
      (_this$onUpdateCallbac = _this.onUpdateCallback) === null || _this$onUpdateCallbac === void 0 || _this$onUpdateCallbac.call(_this, loadedViewportData);
    })();
  }
  setFilters(config) {
    // no-op
  }
  setSorts(config) {
    // no-op
  }
  setReversed(isReversed) {
    // no-op
  }
  close() {
    // no-op
  }
  onUpdate(callback) {
    this.onUpdateCallback = callback;
    return jest.fn();
  }
  get size() {
    return this.items.length;
  }
}
export default MockFileStorageTable;
//# sourceMappingURL=MockFileStorageTable.js.map